module.exports = __webpack_public_path__ + "static/media/zadania-powtorkowe-do-egzaminu-osmoklasisty-matematyka-8-3.0986ea3a.jpg";